export default "__VITE_ASSET__a1f96c84__"